import vTurnstile from "./v-turnstile.vue";

export default Vue => {
  Vue.component("v-turnstile", vTurnstile);
};
